/**
 * Configuración de la API
 * Puedes cambiar la URL base desde aquí o usando variables de entorno
 */
export const API_CONFIG = {
	baseURL: 'https://avansuite.shootthedev.com/cloudservice',
	// baseURL: 'http://localhost:18632',
}
